module.exports = __webpack_public_path__ + "media/images/icons/tada-ffb118dffa85e739bdd38a9e15eaf9c3.svg";